const PAYMENT_METHODS = {
  CREDIT_CARD: {display: 'CREDIT CARD (3% fee)', value: 'Credit Card', showOrder: 0, def: false},
  ACH: {display: 'ACH', value: 'ACH', showOrder: 1, def: false},
  CHECK: {display: 'CHECK', value: 'Check', showOrder: 2, def: false},
  EFT: {display: 'EFT', value: 'EFT', showOrder: 3, def: false},
  CASH: {display: 'CASH', value: 'Cash', showOrder: 4, def: false},
};

export default PAYMENT_METHODS;
